import React from "react";

const starType = (rating, index) => {
  const value = Math.min(5, Math.max(0, Number(rating) || 0));
  const stepped = Math.round(value * 2) / 2;
  const diff = stepped - index;
  if (diff >= 1) return "full";
  if (diff >= 0.5) return "half";
  return "empty";
};

export const formatRating = (rating) => {
  const num = Number(rating);
  if (!Number.isFinite(num) || num <= 0) return "";
  const stepped = Math.round(Math.min(5, num) * 2) / 2;
  return Number.isInteger(stepped) ? String(stepped) : stepped.toFixed(1);
};

function MasterRating({ rating, size = "sm" }) {
  const num = Number(rating);
  const hasRating = Number.isFinite(num) && num > 0;
  const display = hasRating ? Math.round(Math.min(5, num) * 2) / 2 : 0;
  const label = hasRating ? formatRating(display) : "No rating";

  return (
    <div className={`ct-rating ${size}${hasRating ? "" : " none"}`} aria-label={`Rating ${label}`}>
      {hasRating && <span className="ct-rating-value">{label}</span>}
      <span className="ct-rating-stars" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((index) => {
          const fill = starType(display, index);
          const icon = fill === "full" ? "ri-star-fill" : fill === "half" ? "ri-star-half-fill" : "ri-star-line";
          return <i className={`${icon} ${fill}`} key={index} />;
        })}
      </span>
      {!hasRating && <span className="ct-rating-value">No rating</span>}
    </div>
  );
}

export default MasterRating;
